import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Autocomplete, ChipButton, CloseButton, Tooltip, Typography } from 'seagull';
import styles from './PMMapServiceField.module.scss';
function isPracticeManagementIntegrationItem(item) {
    return typeof item !== 'string';
}
export default function PMMapServiceField(props) {
    const { testId, value, options, loading, disabled, tooltip, label, onChange } = props;
    const selectedOptions = useMemo(()=>{
        return options ? options.filter((opt)=>value.includes(opt.id)) : [];
    }, [
        value,
        options
    ]);
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: tooltip ? /*#__PURE__*/ _jsx("div", {
            "data-testid": "".concat(testId, "-tooltip"),
            children: tooltip
        }) : '',
        children: /*#__PURE__*/ _jsx("div", {
            "data-testid": "".concat(testId, "-wrapper"),
            children: /*#__PURE__*/ _jsx(Autocomplete, {
                bi: {
                    name: 'pm_service_mapping'
                },
                multiple: true,
                disableCloseOnSelect: true,
                filterSelectedOptions: true,
                mobile: {
                    renderAsCard: true
                },
                id: testId,
                testId: testId,
                loading: loading,
                disabled: disabled || loading,
                options: options || [],
                getOptionLabel: (opt)=>opt.name,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                value: selectedOptions,
                textFieldProps: {
                    label,
                    placeholder: selectedOptions.length > 0 ? '' : 'Not mapped',
                    alwaysShrinkLabel: true
                },
                onChange: (e, value)=>onChange(value.filter(isPracticeManagementIntegrationItem).map((item)=>item.id)),
                renderTags: (value, getTagProps)=>value.map((opt, index)=>{
                        const tagProps = getTagProps({
                            index
                        }); // eslint-disable-line @typescript-eslint/no-explicit-any
                        return /*#__PURE__*/ _jsxs(ChipButton, {
                            highlight: true,
                            disabled: disabled || loading,
                            className: styles.badge,
                            testId: "".concat(testId, "-tag-").concat(index),
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    children: opt.name
                                }),
                                /*#__PURE__*/ _jsx(CloseButton, {
                                    bi: {
                                        name: 'remove_pm_service_mapping'
                                    },
                                    size: "xsmall",
                                    bordered: true,
                                    disabled: disabled || loading,
                                    onClick: tagProps.onDelete
                                })
                            ]
                        }, opt.id);
                    })
            })
        })
    });
}
